import { NumericFormat } from 'react-number-format';
import { TextField } from "@mui/material";

export default function DecimalEditCell(props) {
  const {
    id,
    value,
    field,
    api,
    colDef,
    hasFocus,
    // ...other DataGrid cell params
  } = props;

  // Handle value change and update DataGrid's edit cell value
  const handleChange = (event) => {
    // Accept both , and . as decimal separator
    const normalized = event.target.value.replace('.', ',');
    api.setEditCellValue({ id, field, value: normalized }, event);
  };

  return (
    <NumericFormat
      customInput={TextField}
      value={value ?? ""}
      onChange={handleChange}
      allowedDecimalSeparators={['.', ',']}
      decimalSeparator=","
      decimalScale={colDef?.decimals ?? 2}
      autoFocus={hasFocus}
      fullWidth
    />
  );
}